import { Component, OnInit } from '@angular/core';
import { trigger, state, style, animate, transition } from '@angular/animations';

@Component({
  selector: 'app-second-page',
  templateUrl: './second-page.component.html',
  styleUrls: ['./second-page.component.scss'],
  animations: [
    trigger('portraitState', [
      state('visible-portrait', style({
        transform: 'translate3d(10%, 0, 0)'
      })),
      state('hide-right-portrait', style({
        transform: 'rotate(90deg)',
        left: '200%'
      })),
      state('hide-left-portrait', style({
        transform: 'rotate(-90deg)',
        left: '-200%'
      })),
      transition('hide-right-portrait => visible-portrait', animate('0.5s ease')),
      transition('visible-portrait => hide-right-portrait', animate('0.7s ease-out')),
      transition('visible-portrait => hide-left-portrait', animate('0.7s ease-out')),
      transition('hide-left-portrait => visible-portrait', animate('0.5s ease'))
    ])
  ]
})
export class SecondPageComponent implements OnInit {

  statePortrait: string = 'hide-right-portrait';

  constructor() { }

  portraitStateIn() {
    this.statePortrait = 'visible-portrait';
  }
  portraitStateOutRight() {
    this.statePortrait = 'hide-right-portrait';
  }
  portraitStateOutLeft() {
    this.statePortrait = 'hide-left-portrait';
  }

  transitionend = (): void => {
    var elm = document.getElementById("swiper-wrapper");
    if (elm != null) {
      var rec = elm.getBoundingClientRect();
      var innerWidth: number = window.innerWidth;

      if (Math.abs(rec.left) == innerWidth) {
        this.portraitStateIn();
      }

      if (Math.abs(rec.left) > innerWidth) {
        this.portraitStateOutLeft();
      }

      if (Math.abs(rec.left) < innerWidth) {
        this.portraitStateOutRight();
      }
    }
  }

  ngOnInit() {
    window.addEventListener('transitionend', this.transitionend, true);
  }

}



// WEBPACK FOOTER //
// ./src/app/second-page/second-page.component.ts